/* eslint-disable lines-between-class-members, prefer-promise-reject-errors */
/* eslint-disable class-methods-use-this */
import axios from 'axios';
import { get } from 'lodash';
import localStore from 'utils/localStorage';
import { mockData } from './mockData';

class ApiService {
  static instance;

  schoolService;
  classService;
  uacService;
  authService;
  centreService;
  onboardingService;
  guardianService;
  financeService;
  childService;
  userService;

  constructor() {
    if (ApiService.instance) {
      return ApiService.instance; // enforce singleton
    }

    this.#createApiServices();
    ApiService.instance = this;
  }

  static getInstance() {
    if (!ApiService.instance) {
      ApiService.instance = new ApiService();
    }
    return ApiService.instance;
  }

  #createApiServices() {
    this.schoolService = this.#createInstance(
      process.env.REACT_APP_MS_SCHOOL_SVC_URL
    );
    this.classService = this.#createInstance(
      process.env.REACT_APP_MS_CLASS_SVC_URL
    );
    this.uacService = this.#createInstance(
      process.env.REACT_APP_MS_UAC_SVC_URL
    );
    this.authService = this.#createInstance(
      process.env.REACT_APP_MS_AUTH_SVC_URL
    );
    this.centreService = this.#createInstance(
      process.env.REACT_APP_MS_CENTRE_SVC_URL
    );
    this.onboardingService = this.#createInstance(
      process.env.REACT_APP_MS_ONBOARDING_SVC_URL
    );
    this.guardianService = this.#createInstance(
      process.env.REACT_APP_MS_GUARDIAN_SVC_URL
    );
    this.financeService = this.#createInstance(
      process.env.REACT_APP_MS_FINANCE_SVC_URL
    );
    this.childService = this.#createInstance(
      process.env.REACT_APP_MS_CHILD_SVC_URL
    );
    this.userService = this.#createInstance(
      process.env.REACT_APP_MS_USER_SVC_URL
    );
    /** @todo add other services */
  }

  #handleError(error) {
    // mock data
    if (mockData[error.response.config.url?.split('?')[0]]) {
      return Promise.resolve(
        mockData[error.response.config.url?.split('?')[0]]
      );
    }

    return Promise.reject({
      message: get(
        error,
        'response.data.error',
        get(error, 'message', 'Something went wrong.')
      ),
      status: get(
        error,
        'response.data.status',
        get(error, 'response.status', 400)
      ),
    });
  }

  #createInstance(baseURL) {
    const instance = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      timeout: 15000,
    });

    instance.interceptors.request.use(request => {
      const token = localStore.getValue('userToken');
      if (token) {
        request.headers.Authorization = `Bearer ${token}`;
      }
      return request;
    }, this.#handleError);

    instance.interceptors.response.use(response => {
      // mock data
      if (mockData[response.config.url?.split('?')[0]]) {
        return mockData[response.config.url?.split('?')[0]];
      }
      return get(response, 'data');
    }, this.#handleError);

    return instance;
  }
}

export default ApiService.getInstance();
